<template>
    <div>
        <div v-if="filters.columns.length>0">
            <filter-form-build-component
                    :form-buttons="filters.buttons||filterButtons"
                    :form-columns="filters.columns"
                    :form-data.sync="filters.form"
                    :form-rules="filters.rules"
                    :label-width="filters.labelWidth||'100px'"
                    @onSubmit="$emit(filters.onSubmit)"
                    form-name="DataTableFilterForm"
                    ref="DataTableFilterForm"
            />
        </div>
        <el-row style="text-align:right" v-if="actions.length > 0">
            <component
                    :class="item.class"
                    :is="item.component||'el-button'"
                    :key="idx"
                    :size="item.size||'small'"
                    :type="item.type||'primary'"
                    @click="item.clickHandler.apply(null, [tableData])"
                    v-for="(item, idx) in actions"
                    v-if="checkCondition(item.conditions, item)"
            >{{item.label||'操作'}}
            </component>
        </el-row>
        <el-row v-if="isMultipleSelectionShow||multipleSelectionOperation.length > 0">
            <el-collapse-transition>
                <div v-show="multipleSelection.length>0">
                    <el-row>
                        <el-col>
                            <div>
                                <ul class="toolbar">
                                    <li>已选中 {{multipleSelection.length}} 项</li>
                                    <li><a :class="item.class" :key="idx"
                                           @click="$emit('enableUsers', multipleSelection)"
                                           href="javascript:void(0)"
                                           v-for="(item, idx) in multipleSelectionOperation">{{item.label}}</a></li>
                                </ul>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-collapse-transition>
        </el-row>
        <slot name="TableTop"></slot>
        <el-row>
            <el-col>
                <div class="grid-content bg-purple">
                    <el-table :data.sync="tableData.data" :ref="tableName" :row-class-name="rowClassName"
                              :span-method="spanMethod" @selection-change="handleSelectionChange" @sort-change="handleSortChange"
                              :default-sort="sort.default"
                              border style="width: 100%">
                        <el-table-column align="center" type="selection" v-if="isMultipleSelectionShow||multipleSelectionOperation.length>0"
                                         width="50">
                        </el-table-column>
                        <template v-for="(column,idx) in columns">
                            <template v-if="checkCondition(column.conditions, column)">
                                <template v-if="column.opts">
                                    <el-table-column
                                            :align="column.align||'center'"
                                            :formatter="column.formatter"
                                            :key="idx"
                                            :label="column.label||column.name"
                                            :prop="column.field"
                                            :width="column.width"
                                    >
                                        <template slot-scope="scope">
                                            <template v-for="(opt, opt_idx) in column.opts">
                                                <el-tooltip :content="typeof opt.label === 'function' ? opt.label.apply(null, [scope.row]) : opt.label||opt.name||''" :key="opt_idx"
                                                            style="margin:0 3px"
                                                            v-if="checkCondition(opt.conditions, scope.row)">
                                                    <a
                                                            @click="clickHandler(opt.clickHandler,scope.$index, scope.row)"
                                                            href="javascript:void(0)"
                                                            style="font-size:14px"
                                                    >
                                                        <component
                                                                :class="opt.class"
                                                                :is="opt.component||'el-icon'"
                                                                :size="opt.size"
                                                                :type="opt.type"
                                                        >
                                                            {{typeof opt.label === 'function' ? opt.label.apply(null, [scope.row]) : opt.label||opt.name||''}}
                                                        </component>
                                                    </a>
                                                </el-tooltip>
                                            </template>
                                        </template>
                                    </el-table-column>

                                </template>
                                <template v-else-if="typeof column.render == 'function'">
                                    <el-table-column
                                            :align="column.align||'center'"
                                            :formatter="column.formatter"
                                            :key="idx"
                                            :label="column.label||column.name"
                                            :prop="column.field"
                                            :width="column.width"
                                            :sortable="getSortable(column.field)"
                                    >
                                        <template slot-scope="scope">
                                            <div v-html="column.render.apply(null, [scope.row, scope.column, scope.row[column.field], scope.$index])"></div>
                                        </template>
                                    </el-table-column>
                                </template>


                                <template v-else>
                                    <template v-if="column.component">
                                        <el-table-column
                                                :align="column.align||'center'"
                                                :formatter="column.formatter"
                                                :key="idx"
                                                :label="column.label||column.name"
                                                :prop="column.field"
                                                :sortable="getSortable(column.field)"
                                                :width="column.width"
                                        >
                                            <template slot-scope="scope">
                                                <component
                                                        :is="column.component"
                                                        :options="column.options"
                                                        :placeholder="column.placeholder"
                                                        :row="scope.row"
                                                        :type="column.type"
                                                        :value-format="column.valueFormat"
                                                        @input="$refs[tableName].toggleRowSelection(scope.row, true)"
                                                        v-if="typeof column.component == 'string'"
                                                        v-model="tableData.data[scope.$index][column.field]"
                                                >
                                                    <el-option
                                                            :key="item.value"
                                                            :label="item.label"
                                                            :value="item.value"
                                                            v-for="(item, idx2) in column.options"
                                                            v-if="column.component == 'el-select'"
                                                    />
                                                </component>
                                                <component
                                                        :is="column.component(scope.row, scope.column, scope.row[column.field], scope.$index)"
                                                        v-bind="column.props||{}"
                                                        v-else-if="typeof column.component == 'function'"></component>
                                            </template>
                                        </el-table-column>
                                    </template>
                                    <template v-else>
                                        <el-table-column
                                                :align="column.align||'center'"
                                                :formatter="column.formatter"
                                                :key="idx"
                                                :label="column.label||column.name"
                                                :prop="column.field"
                                                :sortable="getSortable(column.field)"
                                                :type="column.type"
                                                :width="column.width"
                                        >
                                        </el-table-column>
                                    </template>
                                </template>
                            </template>
                        </template>
                    </el-table>

                </div>
            </el-col>
        </el-row>
        <el-row v-if="isPaginationShow">
            <pagination :handleCurrentChange="handleCurrentChange" :layout="paginationLayout"
                        :page-sizes="pageSizes" :pageSize.sync="currentPageSize" :total="tableData.count"/>
        </el-row>
    </div>
</template>

<script>
    import moment from 'moment'
    import FormBuildComponent from "./FormBuild";
    import FilterFormBuildComponent from "./FilterFormBuild";

    export default {
        name: 'DataTableComponent',
        components: {FilterFormBuildComponent, FormBuildComponent},
        data() {
            return {
                multipleSelection: [],
                filterButtons: [
                    {
                        label: '搜索',
                        type: 'primary',
                        class: 'el-icon-search',
                        size: 'small',
                        clickHandler: $refs => {
                            $refs.validate(valid => {
                                if (valid) {
                                    this.filters.onSubmit()
                                }
                            })
                        }
                    },
                    {
                        label: '清空',
                        type: '',
                        size: 'small',
                        clickHandler: $refs => {
                            $refs.resetFields()
                            if (typeof this.filters.onReset == 'function') {
                                this.filters.onReset()
                            } else {
                                this.filters.onSubmit()
                            }
                        }
                    }
                ]
            }
        },
        props: {
            columns: {
                type: Array,
                default: () => {
                    return []
                }
            },
            tableName: {
                type: String,
                default: 'DataTable'
            },
            tableData: {
                type: Object,
                default: () => {
                    return {
                        data: [],
                        count: 0
                    }
                }
            },
            pageSizes: {
                type: Array,
                default: () => {
                    return [10, 20, 50, 100, 200, 300, 400]
                }
            },
            paginationLayout: {
                type: String,
                default: 'prev, pager, next, sizes, jumper, ->, total'
            },
            spanMethod: Function,
            /*        multipleSelection: {
                    type: Array,
                    default: ()=>{
                      return []
                    }
                  },*/
            multipleSelectionOperation: {
                type: Array,
                default: function () {
                    return []
                }
            },
            page: {
                type: Number,
                default: 1
            },
            pageSize: {
                type: Number,
                default: 10
            },
            sort: {
                type: Object,
                default: ()=> ({
                    fields: [],
                    default: {},
                    params: {}
                })
            },
            isPaginationShow: {
                type: Boolean,
                default: true
            },
            isMultipleSelectionShow: {
                type: Boolean,
                default: false
            },
            filters: {
                type: Object,
                default: () => {
                    return {
                        form: {},
                        columns: [],
                        rules: {},
                        buttons: []
                    }
                }
            },
            actions: {
                type: Array,
                default: () => {
                    return []
                }
            },
            rowClassName: [Function, String]
        },
        computed: {
            currentPageSize: {
                get() {
                    return this.pageSize
                },
                set(newVal) {
                    this.$emit('update:pageSize', newVal)
                }
            },
            filterForm: function () {
                return this.filters.map(item => item.field).reduce((o, val) => {
                    o[val] = '';
                    return o
                }, {})
            },
            filterFormColumnsGroup: function () {
                return [
                    {
                        label: '',
                        columns: this.filters
                    }
                ]
            }
        },
        methods: {
            handleSelectionChange: function (val) {
                this.multipleSelection = val
                this.$emit('handleSelectionChange', val)
            },
            handleCurrentChange: function (page) {
                this.$emit('update:page', page)
            },
            handleSortChange: function ({ column, prop, order }) {
                const newVal = Object.assign({}, this.sort)
                newVal.params[prop] = order
                this.$emit('update:sort', newVal)
            },
            checkCondition: function (conditions, row) {
                if (typeof conditions == 'undefined') {
                    return true
                } else if (typeof conditions == 'boolean') {
                    return conditions
                } else if (typeof conditions == 'function') {
                    return conditions.apply(this, [row])
                } else if (Array.isArray(conditions)) {
                    return conditions.every(condition => {
                        return this.checkCondition(condition, row)
                    })
                }
                /*
                        let checked = true

                        try {
                          return conditions.every(condition => {
                            if (typeof condition == 'function') {
                              return condition.apply(this, [index, row])
                            }
                            else {
                              return Object.keys(condition).every(key => {
                                return row[key] == condition[key]
                              })
                            }
                          })
                        } catch (e) {

                        }

                        return checked*/
            },
            clickHandler: function (clickHandler, index, row) {
                if (typeof clickHandler == 'function') {
                    clickHandler.apply(this, [index, row, this.tableData])
                } else {
                    this.$emit(clickHandler, index, row)
                }
            },
            getSortable: function (field) {
                return this.sort.fields.includes(field) ? 'custom' : false
            }
        },
        watch: {
            filters: {
                deep: true,
                handler: function (newVal) {
                    this.$emit('update:filters', newVal)
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DataTable.vue